export const videolar = {
  title: 'Videolar',
  titleEN: 'Videos',
  description: 'Youtube, Instagram, Tiktok, Facebook, Belgesel, New-Gen Video, Dizi ya da Canlı Yayın. Onedio Video bugne kadar 20\'den fazla trde, 2000’den fazla video retti ve <span style=\'color: #E26F67; font-weight: 600;\'>2 milyardan fazla izlenme aldı.</span> Kreatif, Prodksiyon, Post Prodksiyon ve Medya’yı tek elden birleştiren ender ekiplerden biri. Hem hızlı hem de cost-efektif!',
  descriptionEN: 'YouTube, Instagram, TikTok, Facebook Documentaries, New Age Videos, Series, or Live Broadcasts Onedio Video has produced over 2,000 videos in more than 20 genres and has garnered over 2 billion views to date. We are one of the few teams that combine Creative, Production, Post-Production, and Media under one roof. Both fast and cost-effective! Don\'t forget to subscribe to our channel and send us your brief!',

  tabs: [
    {
      id: 1,
      title: 'Video Tanıtım',
      sliderPerView: 1,
      width: '640px',
      slides: [
        {
          id: 1,
          name: 'Onedio Tanıtım Videosu',
          image: 'https://srv-cdn.onedio.com/store/87f51725cb592153e33b5a1f71752f8cc38a56e662f3f59a18be48e6af5e860b.png',
          url: 'https://player.vimeo.com/video/615919218?h=21b092c028',
          width: '640px',
          height: '360px',
          modal: 'iframe',
          modalTitle: 'Onedio Tanıtım Videosu'
        }
      ]
    },
    {
      id: 2,
      title: 'Newgen',
      sliderPerView: 3,
      width: '100%',
      slides: [
        {
          id: 1,
          name: '#adidasZX etkisi ile tanışmaya hazır mısın?',
          image: 'https://srv-cdn.onedio.com/store/a83c3cb0441cda3cd52b7833ec7fb5f236ad126ea5b50d9174520123cabce73b.png',
          url: 'https://www.instagram.com/reel/CHUlyZxJFhd/embed',
          width: '440px',
          height: '85vh',
          modal: 'iframe',
          modalTitle: '#adidasZX etkisi ile tanışmaya hazır mısın?'
        },
        {
          id: 2,
          name: 'Kimler “Sébium Tertemiz Dans Kiti” kazanmak ister?',
          image: 'https://srv-cdn.onedio.com/store/4cb0f42ab61c5a011f18aecd11cf4e78c60017729712e577628c37cf33038449.png',
          url: 'https://www.instagram.com/reel/CWWKP_6ISLR/embed',
          width: '440px',
          height: '85vh',
          modal: 'iframe',
          modalTitle: 'Kimler “Sébium Tertemiz Dans Kiti” kazanmak ister?'
        },
        {
          id: 3,
          name: 'Gökhan Özoğuz ve Ferit Aktuğ ile Eğlenceli Emoji Quiz',
          image: 'https://srv-cdn.onedio.com/store/d6bd4ba15ce01bb36415aadb71848ba54eb480c142e81ad7b019a4dd1526bdb5.png',
          url: 'https://www.instagram.com/p/CledTk-qpmJ/embed',
          width: '440px',
          height: '85vh',
          modal: 'iframe',
          modalTitle: 'Gökhan Özoğuz ve Ferit Aktuğ ile Eğlenceli Emoji Quiz'
        },
        {
          id: 4,
          name: 'Burçlar Diyet Yaparsa Tepkileri 😂',
          image: 'https://srv-cdn.onedio.com/store/66da593bd5117bef97b363dca21ec3d6f353be130c773c78790bd98ae77b5cc5.png',
          url: 'https://www.instagram.com/reel/Cm7QlPhNEEt/embed',
          width: '440px',
          height: '85vh',
          modal: 'iframe',
          modalTitle: 'Burçlar Diyet Yaparsa Tepkileri 😂'
        },
        {
          id: 5,
          name: 'Eve yeni çıkan gençlerde görülen 5 şey 😂',
          image: 'https://srv-cdn.onedio.com/store/f45858b0142599032d87fcb8e144c7e27a65f1baf67ad642d85fba64985bdfb2.png',
          url: 'https://www.instagram.com/reel/CmzgIOqroJ0/embed',
          width: '440px',
          height: '85vh',
          modal: 'iframe',
          modalTitle: 'Eve yeni çıkan gençlerde görülen 5 şey 😂'
        },
        {
          id: 6,
          name: 'Birini Seç! x Oğuzhan Koç',
          image: 'https://srv-cdn.onedio.com/store/8d817041038a03814c2142123639c13fb350728637f0de344dbc44de555d398c.png',
          url: 'https://www.instagram.com/reel/Chz8EJ2K_Gt/embed',
          width: '440px',
          height: '85vh',
          modal: 'iframe',
          modalTitle: 'Birini Seç! x Oğuzhan Koç'
        },
        {
          id: 7,
          name: 'Aşırı Sıkıcı 5 Üniversite Reklamı 😄',
          image: 'https://srv-cdn.onedio.com/store/47955d68f7831fd597d462197ea65805bd3b89d6e1c304647854479a40e2b9fc.png',
          url: 'https://www.instagram.com/reel/CghIS6hKV0U/embed',
          width: '440px',
          height: '85vh',
          modal: 'iframe',
          modalTitle: 'Aşırı Sıkıcı 5 Üniversite Reklamı 😄'
        },
        {
          id: 8,
          name: 'İnsan Sarrafı 🤣 I Hazal Subaşı 💙',
          image: 'https://srv-cdn.onedio.com/store/a5ff6bc1920368fbfebddd5ee93a67ee4a4a8a1d45aae87d18a8f11e6afc7157.png',
          url: 'https://www.instagram.com/reel/Cnppc9FNgl8/embed',
          width: '440px',
          height: '85vh',
          modal: 'iframe',
          modalTitle: 'İnsan Sarrafı 🤣 I Hazal Subaşı 💙'
        }
      ]
    },
    {
      id: 3,
      title: 'Insight Video',
      sliderPerView: 3,
      width: '100%',
      slides: [
        {
          id: 1,
          name: 'Barbekücü ve Mangalcı',
          image: 'https://srv-cdn.onedio.com/store/abc0f76db883d47849707095141b1078e53de488fc168250779625ca96b3c627.png',
          url: 'https://www.youtube.com/embed/l3PKMjwZ9gM?rel=0',
          modalTitle: 'Barbekücü ve Mangalcı',
          modal: 'iframe'
        },
        {
          id: 2,
          name: 'Bir Kadının Tektaş İstediğini Gösteren 7 İşaret',
          image: 'https://srv-cdn.onedio.com/store/c8f1a813578fb193916565a25e9709d67512b24b0062288e821ac9ec24823c37.png',
          url: 'https://www.youtube.com/embed/BTdmzM-7mMM?rel=0',
          modalTitle: 'Bir Kadının Tektaş İstediğini Gösteren 7 İşaret',
          modal: 'iframe'
        },
        {
          id: 3,
          name: 'Türklerin Aşırı Duygusal Olduğunu Gösteren 8 Durum',
          image: 'https://srv-cdn.onedio.com/store/156fd571566bcf2ca419dc74335464894660fc5d611c0823b56a6a280849bc1b.png',
          url: 'https://www.youtube.com/embed/jYNlRpX4tR0?rel=0',
          modalTitle: 'Türklerin Aşırı Duygusal Olduğunu Gösteren 8 Durum',
          modal: 'iframe'
        }
      ]
    },
    {
      id: 4,
      title: 'Fon Format Video',
      sliderPerView: 3,
      width: '100%',
      slides: [
        {
          id: 1,
          name: 'Oğuzhan Koç Sosyal Medyadan Gelen Soruları Yanıtladı',
          image: 'https://srv-cdn.onedio.com/store/9eb9d93f080d0a36ec2d837fa9920ae0276a53a9e6a9bb60975899d9aefdf2c6.png',
          url: 'https://www.youtube.com/embed/Ml0U11Elyrg?rel=0',
          modal: 'iframe',
          modalTitle: 'Oğuzhan Koç Sosyal Medyadan Gelen Soruları Yanıtladı'
        },
        {
          id: 2,
          name: 'Danla Bilic Sosyal Medyadan Gelen Soruları Yanıtlıyor',
          image: 'https://srv-cdn.onedio.com/store/5d20482b8aee13a0949d5e464aeceedeeec61152eb45e565b3df95e245619623.png',
          url: 'https://www.youtube.com/embed/AiYtoQS_8lk?rel=0',
          modal: 'iframe',
          modalTitle: 'Danla Bilic Sosyal Medyadan Gelen Soruları Yanıtlıyor'
        }
      ]
    },
    {
      id: 5,
      title: 'Uzun Metraj - Canlı Yayın',
      sliderPerView: 3,
      width: '100%',
      slides: [
        {
          id: 1,
          name: '"Yazılı Olmayan Lise Kuralları" | Lise Kafası 1. Bölüm',
          image: 'https://srv-cdn.onedio.com/store/e90f00211a36145a7e85d7cb3852ac0b485d9c750c5029686c8e5bf4a86a94d6.png',
          url: 'https://www.youtube.com/embed/ikAGd3QLmGk?rel=0',
          modal: 'iframe',
          modalTitle: '"Yazılı Olmayan Lise Kuralları" | Lise Kafası 1. Bölüm'
        },
        {
          id: 2,
          name: 'Bazıları için züppe olduk, bazıları için özgürlük!',
          image: 'https://srv-cdn.onedio.com/store/9db7e0de4833e10c01a6d3126f971310629bfa9c30baefbfa26c54fd0735258a.png',
          url: 'https://www.youtube.com/embed/ZOdYXA8qDSM?rel=0',
          modal: 'iframe',
          modalTitle: 'Bazıları için züppe olduk, bazıları için özgürlük!'
        },
        {
          id: 3,
          name: 'BigBossLayf Katılımcılarının Bavullarında Ne Var?',
          image: 'https://srv-cdn.onedio.com/store/95ecf10b2483ae324daa7b5cb05ed4fb0219a90a77fb087d3d21df3e2b05807c.png',
          url: 'https://www.youtube.com/embed/FdwdWpvaozU?rel=0',
          modal: 'iframe',
          modalTitle: 'BigBossLayf Katılımcılarının Bavullarında Ne Var?'
        },
        {
          id: 4,
          name: 'EFSANE CUMA! Hediyeler seni bekliyor!',
          image: 'https://srv-cdn.onedio.com/store/b495e1ed51d3a29425c8798585b8c859f8d153bf597a921eb94711d2df0dd0e9.png',
          url: 'https://www.youtube.com/embed/JyIaqx1y0hw?rel=0',
          modal: 'iframe',
          modalTitle: 'EFSANE CUMA! Hediyeler seni bekliyor!'
        },
        {
          id: 5,
          name: 'Türkiye\'nin İlk Canlı Yayın Hackathon\'u Başladı!',
          image: 'https://srv-cdn.onedio.com/store/124135962a4c720b4dbaa3166ff0879b3a17658364d6184d75eed786efecaf3b.png',
          url: 'https://www.youtube.com/embed/DJmHye6I94Y?rel=0',
          modal: 'iframe',
          modalTitle: 'Türkiye\'nin İlk Canlı Yayın Hackathon\'u Başladı!'
        },
        {
          id: 6,
          name: 'Lenovo Case 2023',
          image: 'https://srv-cdn.onedio.com/store/47f37b29e2fa7e5ffb93af3b5bcb391d4a953d5a387732c62d2190005c972cf4.png',
          url: 'https://player.vimeo.com/video/796008295?h=48e77938ed',
          modal: 'iframe',
          modalTitle: 'Lenovo Case 2023'
        },
        {
          id: 7,
          name: 'Samsung Case 2023',
          image: 'https://srv-cdn.onedio.com/store/09e14ea972a77664d400fa47f1ad5de673d43e8e64974008268d2e4ad88fe9d5.png',
          url: 'https://player.vimeo.com/video/796010084?h=3df036b981',
          modal: 'iframe',
          modalTitle: 'Samsung Case 2023'
        }
      ]
    },
    {
      id: 6,
      title: 'Instant Marketing',
      sliderPerView: 3,
      width: '100%',
      slides: [
        {
          id: 1,
          name: 'Ford Case After',
          image: 'https://srv-cdn.onedio.com/store/4aa84d39e862ddb5be4d67a1f82fd3dc42abcf4f5a1dddbc343aac7dd9362d53.png',
          url: 'https://player.vimeo.com/video/388264203?h=e25308597e',
          modal: 'iframe',
          modalTitle: 'Ford Case After'
        },
        {
          id: 2,
          name: 'Zombi İstilası: İstanbul',
          image: 'https://srv-cdn.onedio.com/store/b2f38790e3ec17b6937cfb619ac6e9fc4fc1253c72392b447d92102f9484deef.png',
          url: 'https://www.youtube.com/embed/_AYtmepfe1w?rel=0',
          modal: 'iframe',
          modalTitle: 'Zombi İstilası: İstanbul'
        }
      ]
    }
  ],
  egTabs: [
    {
      id: 1,
      title: 'Advertisement Video',
      sliderPerView: 1,
      width: '640px',
      slides: [
        {
          id: 1,
          name: 'Onedio Introduction Video',
          image: 'https://srv-cdn.onedio.com/store/87f51725cb592153e33b5a1f71752f8cc38a56e662f3f59a18be48e6af5e860b.png',
          url: 'https://player.vimeo.com/video/615919218?h=21b092c028',
          width: '640px',
          height: '360px',
          modal: 'iframe',
          modalTitle: 'Onedio Introduction Video'
        }
      ]
    },
    {
      id: 2,
      title: 'Newgen',
      sliderPerView: 3,
      width: '100%',
      slides: [
        {
          id: 1,
          name: 'Are you ready to meet the #adidasZX effect?',
          image: 'https://srv-cdn.onedio.com/store/a83c3cb0441cda3cd52b7833ec7fb5f236ad126ea5b50d9174520123cabce73b.png',
          url: 'https://www.instagram.com/reel/CHUlyZxJFhd/embed',
          width: '440px',
          height: '85vh',
          modal: 'iframe',
          modalTitle: 'Are you ready to meet the #adidasZX effect?'
        },
        {
          id: 2,
          name: 'Who wants to win the “Sébium Clean Dance Kit”?',
          image: 'https://srv-cdn.onedio.com/store/4cb0f42ab61c5a011f18aecd11cf4e78c60017729712e577628c37cf33038449.png',
          url: 'https://www.instagram.com/reel/CWWKP_6ISLR/embed',
          width: '440px',
          height: '85vh',
          modal: 'iframe',
          modalTitle: 'Who wants to win the “Sébium Clean Dance Kit”?'
        },
        {
          id: 3,
          name: 'Fun Emoji Quiz with Gökhan Özoğuz and Ferit Aktuğ',
          image: 'https://srv-cdn.onedio.com/store/d6bd4ba15ce01bb36415aadb71848ba54eb480c142e81ad7b019a4dd1526bdb5.png',
          url: 'https://www.instagram.com/p/CledTk-qpmJ/embed',
          width: '440px',
          height: '85vh',
          modal: 'iframe',
          modalTitle: 'Fun Emoji Quiz with Gökhan Özoğuz and Ferit Aktuğ'
        },
        {
          id: 4,
          name: 'Reactions of Zodiac Signs When Dieting 😂',
          image: 'https://srv-cdn.onedio.com/store/66da593bd5117bef97b363dca21ec3d6f353be130c773c78790bd98ae77b5cc5.png',
          url: 'https://www.instagram.com/reel/Cm7QlPhNEEt/embed',
          width: '440px',
          height: '85vh',
          modal: 'iframe',
          modalTitle: 'Reactions of Zodiac Signs When Dieting 😂'
        },
        {
          id: 5,
          name: '5 Things Seen in Young People Moving Out 😂',
          image: 'https://srv-cdn.onedio.com/store/f45858b0142599032d87fcb8e144c7e27a65f1baf67ad642d85fba64985bdfb2.png',
          url: 'https://www.instagram.com/reel/CmzgIOqroJ0/embed',
          width: '440px',
          height: '85vh',
          modal: 'iframe',
          modalTitle: '5 Things Seen in Young People Moving Out 😂'
        },
        {
          id: 6,
          name: 'Choose One! x Oğuzhan Koç',
          image: 'https://srv-cdn.onedio.com/store/8d817041038a03814c2142123639c13fb350728637f0de344dbc44de555d398c.png',
          url: 'https://www.instagram.com/reel/Chz8EJ2K_Gt/embed',
          width: '440px',
          height: '85vh',
          modal: 'iframe',
          modalTitle: 'Choose One! x Oğuzhan Koç'
        },
        {
          id: 7,
          name: '5 Extremely Boring University Ads 😄',
          image: 'https://srv-cdn.onedio.com/store/47955d68f7831fd597d462197ea65805bd3b89d6e1c304647854479a40e2b9fc.png',
          url: 'https://www.instagram.com/reel/CghIS6hKV0U/embed',
          width: '440px',
          height: '85vh',
          modal: 'iframe',
          modalTitle: '5 Extremely Boring University Ads 😄'
        },
        {
          id: 8,
          name: 'Human Detector 🤣 I Hazal Subaşı 💙',
          image: 'https://srv-cdn.onedio.com/store/a5ff6bc1920368fbfebddd5ee93a67ee4a4a8a1d45aae87d18a8f11e6afc7157.png',
          url: 'https://www.instagram.com/reel/Cnppc9FNgl8/embed',
          width: '440px',
          height: '85vh',
          modal: 'iframe',
          modalTitle: 'Human Detector 🤣 I Hazal Subaşı 💙'
        }
      ]
    },
    {
      id: 3,
      title: 'Insight Video',
      sliderPerView: 3,
      width: '100%',
      slides: [
        {
          id: 1,
          name: 'Barbecue and Grill Master',
          image: 'https://srv-cdn.onedio.com/store/abc0f76db883d47849707095141b1078e53de488fc168250779625ca96b3c627.png',
          url: 'https://www.youtube.com/embed/l3PKMjwZ9gM?rel=0',
          modalTitle: 'Barbecue and Grill Master',
          modal: 'iframe'
        },
        {
          id: 2,
          name: '7 Signs a Woman Wants a Diamond Ring',
          image: 'https://srv-cdn.onedio.com/store/c8f1a813578fb193916565a25e9709d67512b24b0062288e821ac9ec24823c37.png',
          url: 'https://www.youtube.com/embed/BTdmzM-7mMM?rel=0',
          modalTitle: '7 Signs a Woman Wants a Diamond Ring',
          modal: 'iframe'
        },
        {
          id: 3,
          name: '8 Situations Showing Turks Are Overly Emotional',
          image: 'https://srv-cdn.onedio.com/store/156fd571566bcf2ca419dc74335464894660fc5d611c0823b56a6a280849bc1b.png',
          url: 'https://www.youtube.com/embed/jYNlRpX4tR0?rel=0',
          modalTitle: '8 Situations Showing Turks Are Overly Emotional',
          modal: 'iframe'
        }
      ]
    },
    {
      id: 4,
      title: 'Background Format Video',
      sliderPerView: 3,
      width: '100%',
      slides: [
        {
          id: 1,
          name: 'Oğuzhan Koç Answered Questions from Social Media',
          image: 'https://srv-cdn.onedio.com/store/9eb9d93f080d0a36ec2d837fa9920ae0276a53a9e6a9bb60975899d9aefdf2c6.png',
          url: 'https://www.youtube.com/embed/Ml0U11Elyrg?rel=0',
          modal: 'iframe',
          modalTitle: 'Oğuzhan Koç Answered Questions from Social Media'
        },
        {
          id: 2,
          name: 'Danla Bilic Answers Questions from Social Media',
          image: 'https://srv-cdn.onedio.com/store/5d20482b8aee13a0949d5e464aeceedeeec61152eb45e565b3df95e245619623.png',
          url: 'https://www.youtube.com/embed/AiYtoQS_8lk?rel=0',
          modal: 'iframe',
          modalTitle: 'Danla Bilic Answers Questions from Social Media'
        }
      ]
    },
    {
      id: 5,
      title: 'Feature Length - Live Broadcast',
      sliderPerView: 3,
      width: '100%',
      slides: [
        {
          id: 1,
          name: '"Unwritten High School Rules" | High School Head Episode 1',
          image: 'https://srv-cdn.onedio.com/store/e90f00211a36145a7e85d7cb3852ac0b485d9c750c5029686c8e5bf4a86a94d6.png',
          url: 'https://www.youtube.com/embed/ikAGd3QLmGk?rel=0',
          modal: 'iframe',
          modalTitle: '"Unwritten High School Rules" | High School Head Episode 1'
        },
        {
          id: 2,
          name: 'For some, we were snobs, for others, freedom!',
          image: 'https://srv-cdn.onedio.com/store/9db7e0de4833e10c01a6d3126f971310629bfa9c30baefbfa26c54fd0735258a.png',
          url: 'https://www.youtube.com/embed/ZOdYXA8qDSM?rel=0',
          modal: 'iframe',
          modalTitle: 'For some, we were snobs, for others, freedom!'
        },
        {
          id: 3,
          name: 'What\'s in the Suitcases of BigBossLayf Participants?',
          image: 'https://srv-cdn.onedio.com/store/95ecf10b2483ae324daa7b5cb05ed4fb0219a90a77fb087d3d21df3e2b05807c.png',
          url: 'https://www.youtube.com/embed/FdwdWpvaozU?rel=0',
          modal: 'iframe',
          modalTitle: 'What\'s in the Suitcases of BigBossLayf Participants?'
        },
        {
          id: 4,
          name: 'LEGENDARY FRIDAY! Gifts are waiting for you!',
          image: 'https://srv-cdn.onedio.com/store/b495e1ed51d3a29425c8798585b8c859f8d153bf597a921eb94711d2df0dd0e9.png',
          url: 'https://www.youtube.com/embed/JyIaqx1y0hw?rel=0',
          modal: 'iframe',
          modalTitle: 'LEGENDARY FRIDAY! Gifts are waiting for you!'
        },
        {
          id: 5,
          name: 'Turkey\'s First Live Broadcast Hackathon Has Started!',
          image: 'https://srv-cdn.onedio.com/store/124135962a4c720b4dbaa3166ff0879b3a17658364d6184d75eed786efecaf3b.png',
          url: 'https://www.youtube.com/embed/DJmHye6I94Y?rel=0',
          modal: 'iframe',
          modalTitle: 'Turkey\'s First Live Broadcast Hackathon Has Started!'
        },
        {
          id: 6,
          name: 'Lenovo Case 2023',
          image: 'https://srv-cdn.onedio.com/store/47f37b29e2fa7e5ffb93af3b5bcb391d4a953d5a387732c62d2190005c972cf4.png',
          url: 'https://player.vimeo.com/video/796008295?h=48e77938ed',
          modal: 'iframe',
          modalTitle: 'Lenovo Case 2023'
        },
        {
          id: 7,
          name: 'Samsung Case 2023',
          image: 'https://srv-cdn.onedio.com/store/09e14ea972a77664d400fa47f1ad5de673d43e8e64974008268d2e4ad88fe9d5.png',
          url: 'https://player.vimeo.com/video/796010084?h=3df036b981',
          modal: 'iframe',
          modalTitle: 'Samsung Case 2023'
        }
      ]
    },
    {
      id: 6,
      title: 'Instant Marketing',
      sliderPerView: 3,
      width: '100%',
      slides: [
        {
          id: 1,
          name: 'Ford Case After',
          image: 'https://srv-cdn.onedio.com/store/4aa84d39e862ddb5be4d67a1f82fd3dc42abcf4f5a1dddbc343aac7dd9362d53.png',
          url: 'https://player.vimeo.com/video/388264203?h=e25308597e',
          modal: 'iframe',
          modalTitle: 'Ford Case After'
        },
        {
          id: 2,
          name: 'Zombie Invasion: Istanbul',
          image: 'https://srv-cdn.onedio.com/store/b2f38790e3ec17b6937cfb619ac6e9fc4fc1253c72392b447d92102f9484deef.png',
          url: 'https://www.youtube.com/embed/_AYtmepfe1w?rel=0',
          modal: 'iframe',
          modalTitle: 'Zombie Invasion: Istanbul'
        }
      ]
    }
  ]
}
